import React from 'react'

export const BoxHeaderTypography = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, children, ...rest }, ref) => {
    return <p ref={ref}
              className={`uppercase font-bold ${className ?? ''}`} {...rest}>{children}</p>
  })